import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

export async function ExportExcelForUpdatePostNumber(
  dataUse,
  selectedGCode,
  selectedContract
) {
  // สร้าง Workbook
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(`ประเภท ${selectedGCode}`); // ใช้ GCODE เป็นชื่อ Sheet

  // กำหนดคอลัมน์ของ Worksheet
  worksheet.columns = [
    { header: "ลำดับ", key: "no", width: 10 },
    { header: "id", key: "id", width: 2 },
    { header: "รอบวันที่", key: "date", width: 15 },
    { header: "ประเภทลูกค้า", key: "cusType", width: 15 },
    { header: "เลขที่สัญญา", key: "contno", width: 15 },
    { header: "ชื่อลูกค้า", key: "cusName", width: 30 },
    { header: "ที่อยู่", key: "addr", width: 50 },
    { header: "zipcode", key: "zipcode", width: 10 },
    { header: "ems จดหมาย", key: "emsNo", width: 25 },
    { header: "ems ใบตอบกลับ", key: "emsResponeNo", width: 25 },
  ];

  // ✅ ซ่อนคอลัมน์ M-P (index 13–16)
  [2].forEach((col) => {
    worksheet.getColumn(col).hidden = true;
  });

  // เพิ่มข้อมูลในแต่ละแถว
  dataUse?.forEach((data, index) => {
    worksheet.addRow([
      index + 1,
      data.id,
      dayjs(data.datetime).format("YYYY-MM-DD"), // วันที่ส่ง
      data.customerTypeID === 0
        ? "ผู้เช่าซื้อ"
        : "คนค้ำ " + data.customerTypeID,
      data.contractNo,
      data.customerFullname,
      data.ADDR + `  (ที่อยู่${data.ADDRNO})`,
      data.zipcode,
    ]);
  });

  // จัดรูปแบบเซลล์ใน Worksheet
  worksheet.eachRow((row) => {
    row.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "center" }; // จัดกึ่งกลางแนวตั้งและแนวนอน
    });
  });

  // สร้างไฟล์และดาวน์โหลด
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  // ดาวน์โหลดไฟล์
  saveAs(
    blob,
    `รายงานบอกเลิกสัญญา${
      selectedContract.label
    }(${selectedGCode}) ${dayjs().format("YYYY_MM_DD")}.xlsx`
  );
}
